import ThemeOverrideProps from 'ThemeOverrideProps';
import {StyleProp, StyleSheet, ViewStyle} from 'react-native';

const {fontRegular, fontBold, fontExtraBold} = ThemeOverrideProps.sheetStyles;

export const stylesFn = () => {
  return StyleSheet.create({
    scrollViewContentContainer: {
      backgroundColor: '#FAFAFA',
      flexGrow: 1,
    },

    container: {
      flex: 1,
      backgroundColor: '#FAFAFA',
    },

    optionContainer: {
      flex: 1,
      paddingVertical: 12,
      paddingHorizontal: 10,
      gap: 8,
    },

    iconStyle: {
      width: 30,
      marginRight: 20,
    },
    iconStyleInstantBankActive: {
      width: 50,
      height: 50,
      marginLeft: -10,
    },

    iconStyleRTPHeader: {
      width: 100,
      height: 100,
    },

    rtpHeaderContainer: {
      flexDirection: 'column',
      alignItems: 'center',
      gap: 10,
      marginBottom: 24,
      marginTop: 50,
    },
    rtpHeaderText: {
      fontSize: 20,
      textAlign: 'center',
      lineHeight: 24,
      letterSpacing: -0.01,
      color: '#000',
      ...fontExtraBold,
    },

    orLineContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
      marginTop: 8,
      justifyContent: 'center',
    },

    orLineText: {
      fontSize: 13,
      color: '#7A7A7A',
      ...fontExtraBold,
      height: 20,
      letterSpacing: -0.39,
    },

    iconOrLineLeft: {
      width: 16,
      height: 10,
    },

    iconOrLineRight: {
      width: 16,
      height: 10,
    },

    playthroughInfoContainer: {
      marginTop: 35,
      marginBottom: 35,
      marginHorizontal: 10,
      padding: 12,
      backgroundColor: '#F2FBFF',
      borderWidth: 1,
      borderColor: '#CDE9FC',
      borderRadius: 4,
      flexDirection: 'row',
      alignItems: 'flex-start',
    },

    playthroughInfoIcon: {
      width: 16,
      height: 16,
      marginRight: 3,
    },

    playthroughInfoTextContainer: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      marginTop: -2,
      flexWrap: 'wrap',
      width: '90%',
    },

    playthroughInfoTitle: {
      fontSize: 14,
      ...fontBold,
      color: '#333333',
    },

    playthroughInfoText: {
      fontSize: 13,
      ...fontRegular,
      color: 'rgba(0, 0, 0, 0.8)',
    },
  });
};

export const cardStylesFn = (isDisabled: boolean, containerStyle?: StyleProp<ViewStyle>) => {
  return StyleSheet.create({
    container: {
      borderWidth: 1,
      borderColor: '#DCDCDC',
      backgroundColor: isDisabled ? '#F2F1F1' : '#FFFFFF',
      height: 100,
      width: '100%',
      flexDirection: 'row',
      alignItems: 'center',
      borderRadius: 5,
      paddingHorizontal: 20,
      ...(containerStyle as object),
    },
    contentContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      flex: 0.5,
    },
    textContainer: {
      width: '83%',
    },
    title: {
      fontSize: 16,
      lineHeight: 20.22,
      letterSpacing: -0.01,
      color: '#2D2D2D',
      ...fontExtraBold,
    },
    secondaryText: {
      fontSize: 13,
      lineHeight: 20.22,
      letterSpacing: -0.01,
      color: '#333',
      ...fontRegular,
    },
    rightArrowContainer: {
      alignItems: 'flex-end',
    },
    arrowIconStyle: {
      width: 10,
    },
    badge: {
      position: 'absolute',
      left: 8,
      top: -4,
    },

    instantUnlockedContainer: {
      backgroundColor: '#DAFBD5',
      borderRadius: 5,
      paddingHorizontal: 5,
      paddingVertical: 3,
      width: 133,
      flexDirection: 'row',
      alignItems: 'center',
      gap: 5,
      marginTop: 10,
      marginLeft: 40,
    },
    instantUnlockedText: {
      fontSize: 10,
      lineHeight: 16.8,
      letterSpacing: -0.01,
      ...fontBold,
      color: '#333',
    },

    instantUnlockedIcon: {
      width: 17,
      height: 17,
      marginRight: 0,
    },
  });
};
